import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const SaveInvoice = async (invoice, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/Invoice/save`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(invoice),
      });

      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { form: "Access token is missing." };
  }
};

const safeParseFirstAreaID = (areaIDs) => {
  try {
    const parsedAreaIDs = typeof areaIDs === "string" ? JSON.parse(areaIDs) : Array.isArray(areaIDs)
      ? areaIDs : [];
    return parsedAreaIDs;
  } catch {
    console.log('error');
    return [];
  }
};

export const SaveAssessmentAmount = async (WR, navigate) => {
  const accesstoken = getToken();
  if (accesstoken) {
    let Payload =
      {
        ...WR,
        propertyAreaIDs: safeParseFirstAreaID(WR.propertyAreaIDs),
        
      };
    try {
      const response = await fetch(`${dev_baseUrl}/WorkRequirement/save`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accesstoken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(Payload),
      });

      const data = await response.json();
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else {
        return data;
      }
    } catch (error) {
      console.error("Network error:", error);
      return {
        isError: true,
        message: "An error occurred. Please try again later.",
        error: error,
      };
    }
  } else {
    console.warn("Access token is not available.");
    return { form: "Access token is missing." };
  }
};